module.exports = __webpack_public_path__ + "img/OurPractice2.076d2865.png";